import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import PlanListFilter from 'components/sales/ListFilters/PlanListFilter';

const PlanScheduleList = ({
        history,
        planListing,
        planListingData = [],
        fetchZones,
        getFetchZones = null,
        getListFilterData,
        filterDropdownList = []
    }) => {
    const headers = [
        'Site Number',
        'User Email',
        'Business Name',
        'Plan Date',
        'Agenda',
        'Message',
        'Creation On',
        'Created By',
        'Actions',
    ];
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isStatusSuccess, setIsStatusSuccess] = useState(false);
    const [isRoleId, setIsRoleId] = useState(null);
    const {baseUrl} = useContext(BaseUrl);

    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(localStorage.getItem('roles'));
            roles && setIsRoleId(roles[0].pivot.role_id);
        })();
    }, []);


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await planListing(1, filterData)
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'site_number',
            'user_email',
            'client_name',
            'plan_date',
            'agenda',
            'message',
            'created_at',
            'created_by'
        ];

        if (planListingData !== undefined && planListingData.data) {
            const data = planListingData.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    element.status === 1 ?
                    {
                        Action: [
                            {
                                name: 'Add Meeting',
                                link: `/dashboard/brand-activation/schedule-plan-meeting/${element['site_id']}`
                            },
                        ],
                    } : {
                        Action: [
                            {
                                name: 'Meeting Created',
                                link: ``
                            },
                        ],
                    }
                )
            );
            data && setListData(data);
            // if (data) {
            //     const newData = data.map(function (obj) {
            //       delete obj['id'];
            //       return obj;
            //     });
            //     newData && setListData(newData);
            //   }
            setPageCount(Math.ceil(planListingData.total / planListingData.per_page));
        }
    }, [planListingData]);

    const applyFilter = async (filterData) => {
        localStorage.setItem("planListingDataFilter", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await planListing(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    useEffect(() => {
        (async () => {
            await getListFilterData(2);
        })();
    }, []);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""/>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await planListing(val.selected + 1, filter);
        localStorage.setItem('page', val.selected + 1)
        setIsLoading(false);
    };

    const getZones = (val) => {
        if (val) fetchZones(val);
    };

    const closeSuccess = () => {
        setIsLoading(true);
        setIsStatusSuccess(!isStatusSuccess);
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.planScheduleList}
            Buttons={headerBtns}
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                detailList={planListingData && planListingData.data}
                pageCount={pageCount}
                srNo={planListingData?.from}
                onPageChange={onPageChange}
                currentPage={localStorage.getItem('page')}
            />

            <PlanListFilter
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                listFilterData={filterDropdownList && filterDropdownList.data}
                isRoleId={isRoleId}
                BaplanListingDataFilter={true}
            />

            <ModalPop
                title={localization.updatedSuccessfully}
                show={isStatusSuccess}
                handleModalHide={closeSuccess}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt=""/>
                    </div>
                    <h5>{localization.leadStatusupdatedsuccessfully}</h5>
                    <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
                        {localization.continue}
                        <img src={Images?.ArrowRight} alt=""/>
                    </Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default PlanScheduleList;
